export const richHTML = (
    value: string | null | undefined,
): { __html: string } => ({
    __html: value ?? "",
});
